import React from 'react'
import PropTypes from "prop-types"
import styled from 'styled-components';

const Btn = styled.a`
  padding: 1.6em 1.9em;
  border: 1px solid #FFF;
  border-radius: 40px;
  font-size: 1em;
  color: #FFF;
  background-color: transparent;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  line-height: 1;
  &:hover{
    border-color: #FDC910;
    color: #FDC910;
  }

  &[data-size=sm]{
    font-size: 0.85em;
    padding: .8em 2em;
  }
`

const BtnSecondary = styled(Btn)`
background-color: #00CE5A;
`

const Button = ({ children, primary, anchor, size }) => (
  <>
  {primary ? (
    <Btn data-size={size} href={anchor} >{children}</Btn>
  ) : 
  (<BtnSecondary data-size={size} href={anchor}>{children}</BtnSecondary>)}
  </>
)


Button.propTypes = {
  anchor: PropTypes.string,
  primary: PropTypes.bool,
  size: PropTypes.string,
}

Button.defaultProps = {
  anchor: ``,
  primary: true,
  size: 'md'
}


export default Button